import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import {
  selectInlineVisitTimeSlots,
  selectProgressSchedule,
  selectProgressVisitType,
} from '../../../redux/appointmentForm/selectors';
import { appointmentProgressActions } from '../../../redux/appointmentForm/progress-types';
import withCareUserSubtitle from '../hocs/withCareUserSubtitle';

const mapStateToProps = state => ({
  timeSlots: selectInlineVisitTimeSlots(state),
  visitType: selectProgressVisitType(state),
  schedule: selectProgressSchedule(state),
});

const mapDispatchToProps = {
  setScheduleData: appointmentProgressActions.setScheduleData,
};

export const enhance = compose(
  injectIntl,
  withCareUserSubtitle,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AvailableTimeSlots/enhance.js